import {
  BookOpen, Calculator, Wallet, FileText, Receipt, TrendingUp, Building2,
  Cloud, GraduationCap, Wrench, ArrowRightLeft, Settings, LifeBuoy, Sparkles,
  Briefcase, PiggyBank, Landmark, ShieldCheck, BarChart3, Coins,
  Handshake, Lightbulb, MessageSquare, Users, Heart, Award, CheckCircle2,
  Target, Clock, Star, Zap, Rocket, ThumbsUp, Scale, ArrowRight, MapPin, Phone,
} from "lucide-react";

export const iconMap = {
  BookOpen, Calculator, Wallet, FileText, Receipt, TrendingUp, Building2,
  Cloud, GraduationCap, Wrench, ArrowRightLeft, Settings, LifeBuoy, Sparkles,
  Briefcase, PiggyBank, Landmark, ShieldCheck, BarChart3, Coins,
  Handshake, Lightbulb, MessageSquare, Users, Heart, Award, CheckCircle2,
  Target, Clock, Star, Zap, Rocket, ThumbsUp, Scale, ArrowRight, MapPin, Phone,
};

export const iconNames = Object.keys(iconMap);

export const getIcon = (name) => iconMap[name] || Sparkles;
